import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
  Slot,
  Text,
  TextField,
} from "@radix-ui/themes";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useFetch } from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";

import { useAppStore } from "../../stores/RootStore";
import { useEffect } from "react";

type EnterInputs = {
  email: string;
};

export default function ForgetView() {
  const store = useAppStore();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<EnterInputs>();
  const [{ response }, doFetchLogin] = useFetch(`/users/sessions`, true);

  const onSubmit: SubmitHandler<EnterInputs> = (data) => {
    doFetchLogin({ method: "POST", data: data });
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (response != null && response.data.status == "ok") {
      console.log("redirect");
      alert(
        "Если электронная почта указана верно, то на неё придётся письмо с последующими инструкциями"
      );
      navigate("/");
    }
  }, [response]);

  return (
    <Flex height="100%" justify="center" align="center">
      <Card style={{ maxWidth: 420, minWidth: 420 }}>
        <Heading mb="4" mt="2" mx="2" weight="bold">
          Восстановление пароля
        </Heading>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col gap-4 px-2"
        >
          <Controller
            control={control}
            name="email"
            rules={{ required: true }}
            render={({ field: { onChange, onBlur, value } }) => (
              <label>
                <Text as="div" size="1" mb="1" weight="medium">
                  Электронная почта
                </Text>
                <TextField.Input onChange={onChange} />
                {errors.email && <div role="alert" className="text-sm text-red-600">Введите электронную почту</div>}
              </label>
            )}
          />
          <Button my="4">Восстановить пароль</Button>
        </form>
      </Card>
    </Flex>
  );
}
